// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_8b1c0c52 {
  margin: 0;
  padding: 0;
  border: 0;
}
.table_8b1c0c52 {
  width: 100%;
  border-radius: 0.333em;
}
.table_fixed_8b1c0c52 {
  table-layout: fixed;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) {
  outline-offset: -2px;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > a,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > span,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > div {
  outline: none;
  box-shadow: none;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > a:hover,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > span:hover,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > div:hover {
  outline: none;
  box-shadow: none;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li > a,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li > span,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li > div {
  outline: none;
  box-shadow: none;
}
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li > a:hover,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li > span:hover,
.table_fixed_8b1c0c52 .table__col_8b1c0c52:has(a:focus-visible) > ul > li > div:hover {
  outline: none;
  box-shadow: none;
}
.table_fixed_8b1c0c52 .table__col_white-space-normal_8b1c0c52 {
  white-space: normal;
}
.table_v-align-middle_8b1c0c52 .table__col_8b1c0c52 {
  vertical-align: middle;
}
.table_v-align-baseline_8b1c0c52 .table__col_8b1c0c52 {
  vertical-align: baseline;
}
.table_v-align-bottom_8b1c0c52 .table__col_8b1c0c52 {
  vertical-align: bottom;
}
.table_v-align-top_8b1c0c52 .table__col_8b1c0c52 {
  vertical-align: top;
}
.table_bordered-grid_8b1c0c52 .table__col_8b1c0c52 {
  border: 0.084rem solid #dce1e5;
  padding-left: 1.334rem;
  padding-right: 1.334rem;
}
.table_bordered-grid_8b1c0c52 .table__col_8b1c0c52:first-child {
  padding-left: 1.334rem;
}
.table_bordered-grid_8b1c0c52 .table__col_8b1c0c52:last-child {
  padding-right: 1.334rem;
}
.table_bordered-columns_8b1c0c52 {
  border: 1px solid #dce1e5;
}
.table_bordered-columns_8b1c0c52 .table__col_8b1c0c52 {
  border-left: 1px solid #dce1e5;
  border-right: 1px solid #dce1e5;
}
.table_bordered-columns_8b1c0c52 .table__col_separated_8b1c0c52 {
  border-right-width: 0.167rem;
}
.table__title_8b1c0c52 {
  font-weight: 600;
}
.table__caption_8b1c0c52 {
  text-align: left;
  padding: 0 0 2rem 0;
}
.table__row_head_8b1c0c52 > .table__col_8b1c0c52 {
  padding-top: 0.834rem;
  padding-bottom: 0.834rem;
  vertical-align: middle;
  white-space: normal;
  font-weight: 600;
}
.table__row_head_8b1c0c52 > .table__col_v-align-middle_8b1c0c52 {
  vertical-align: middle;
}
.table__row_head_8b1c0c52 > .table__col_v-align-baseline_8b1c0c52 {
  vertical-align: baseline;
}
.table__row_head_8b1c0c52 > .table__col_v-align-bottom_8b1c0c52 {
  vertical-align: bottom;
}
.table__row_head_8b1c0c52 > .table__col_v-align-top_8b1c0c52 {
  vertical-align: top;
}
.table__row_head_8b1c0c52 > .table__col_nowrap_8b1c0c52 {
  white-space: nowrap;
}
.table__row_foot_8b1c0c52 > .table__col_8b1c0c52 {
  padding-top: 0.834rem;
  padding-bottom: 0.834rem;
  vertical-align: middle;
  white-space: normal;
  font-weight: 600;
}
.table__row_foot_8b1c0c52 > .table__col_v-align-middle_8b1c0c52 {
  vertical-align: middle;
}
.table__row_foot_8b1c0c52 > .table__col_v-align-baseline_8b1c0c52 {
  vertical-align: baseline;
}
.table__row_foot_8b1c0c52 > .table__col_v-align-bottom_8b1c0c52 {
  vertical-align: bottom;
}
.table__row_foot_8b1c0c52 > .table__col_v-align-top_8b1c0c52 {
  vertical-align: top;
}
.table__row_foot_8b1c0c52 > .table__col_nowrap_8b1c0c52 {
  white-space: nowrap;
}
.table__row_body_zebra_8b1c0c52:not(:only-of-type):nth-child(odd):not(.table__row_hovered_8b1c0c52):not(.table__row_highlighted_8b1c0c52) {
  background-color: #f8f9fa;
}
.table__row_body_custom_zebra_8b1c0c52:not(.table__row_hovered_8b1c0c52) {
  background-color: #f8f9fa;
}
.table__row_body_8b1c0c52 > .table__col_8b1c0c52 {
  min-height: 1.666rem;
  height: 100%;
  box-sizing: content-box;
  line-height: 1.9;
}
.table_8b1c0c52 thead + tbody .table__row_body_8b1c0c52:not(.table__row_border_8b1c0c52):first-child .table__col_8b1c0c52 {
  border-top: 1px solid #dce1e5;
}
.table__row_border_8b1c0c52 > .table__col_8b1c0c52 {
  border-color: transparent;
}
.table__row_align-middle_8b1c0c52 > .table__col_8b1c0c52 {
  vertical-align: middle;
}
.table__row_highlighted_8b1c0c52 {
  background-color: rgba(64,194,201,0.2) !important;
}
.table__subtitle_8b1c0c52 {
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 0.834rem;
  line-height: 1.715;
  letter-spacing: normal;
  font-stretch: normal;
}
.table__col_8b1c0c52 {
  margin: 0;
  border: 0;
  padding: 0.334rem 0.667rem;
  vertical-align: top;
  white-space: nowrap;
}
.table__col_v-align-middle_8b1c0c52 {
  vertical-align: middle;
}
.table__col_v-align-baseline_8b1c0c52 {
  vertical-align: baseline;
}
.table__col_v-align-bottom_8b1c0c52 {
  vertical-align: bottom;
}
.table__col_v-align-top_8b1c0c52 {
  vertical-align: top;
}
.table__col_8b1c0c52:first-child {
  padding-left: 1.334rem;
}
.table__col_8b1c0c52:last-child {
  padding-right: 1.334rem;
}
.table__col_default-padding_8b1c0c52:first-child {
  padding-left: 0.667rem;
}
.table__col_default-padding_8b1c0c52:last-child {
  padding-right: 0.667rem;
}
.table__col_left_8b1c0c52 {
  text-align: left;
}
.table__col_center_8b1c0c52 {
  text-align: center;
}
.table__col_right_8b1c0c52 {
  text-align: right;
}
.table__col_caption_8b1c0c52 {
  background-color: #eaedef;
  font-weight: 600;
}
.table__col_block_8b1c0c52 {
  padding: 0;
  height: 3.334rem;
}
.table__col_number_8b1c0c52 {
  text-align: center;
  width: 3.917rem;
  line-height: 1.715;
}
.table__col_number_8b1c0c52:first-child {
  padding-left: 0.667rem;
}
.table__col_white-space-normal_8b1c0c52 {
  white-space: normal;
}
.table__col_8b1c0c52 .svg {
  vertical-align: middle;
  display: block;
}
.table__col_8b1c0c52 .svg svg {
  display: inline-block !important;
  vertical-align: inherit;
}
.table_data-table-rows_8b1c0c52 .table__row_body_8b1c0c52 .table__col_8b1c0c52 {
  padding: 0 1rem;
  height: 2rem;
}
.table_data-table-rows_8b1c0c52 .table__row_head_8b1c0c52 .table__col_8b1c0c52,
.table_data-table-rows_8b1c0c52 .table__row_foot_8b1c0c52 .table__col_8b1c0c52 {
  height: 3.333rem;
  padding: 0 0.667rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_8b1c0c52`,
	"table_fixed": `table_fixed_8b1c0c52`,
	"table__col": `table__col_8b1c0c52`,
	"table__col_white-space-normal": `table__col_white-space-normal_8b1c0c52`,
	"table_v-align-middle": `table_v-align-middle_8b1c0c52`,
	"table_v-align-baseline": `table_v-align-baseline_8b1c0c52`,
	"table_v-align-bottom": `table_v-align-bottom_8b1c0c52`,
	"table_v-align-top": `table_v-align-top_8b1c0c52`,
	"table_bordered-grid": `table_bordered-grid_8b1c0c52`,
	"table_bordered-columns": `table_bordered-columns_8b1c0c52`,
	"table__col_separated": `table__col_separated_8b1c0c52`,
	"table__title": `table__title_8b1c0c52`,
	"table__caption": `table__caption_8b1c0c52`,
	"table__row_head": `table__row_head_8b1c0c52`,
	"table__col_v-align-middle": `table__col_v-align-middle_8b1c0c52`,
	"table__col_v-align-baseline": `table__col_v-align-baseline_8b1c0c52`,
	"table__col_v-align-bottom": `table__col_v-align-bottom_8b1c0c52`,
	"table__col_v-align-top": `table__col_v-align-top_8b1c0c52`,
	"table__col_nowrap": `table__col_nowrap_8b1c0c52`,
	"table__row_foot": `table__row_foot_8b1c0c52`,
	"table__row_body_zebra": `table__row_body_zebra_8b1c0c52`,
	"table__row_hovered": `table__row_hovered_8b1c0c52`,
	"table__row_highlighted": `table__row_highlighted_8b1c0c52`,
	"table__row_body_custom_zebra": `table__row_body_custom_zebra_8b1c0c52`,
	"table__row_body": `table__row_body_8b1c0c52`,
	"table__row_border": `table__row_border_8b1c0c52`,
	"table__row_align-middle": `table__row_align-middle_8b1c0c52`,
	"table__subtitle": `table__subtitle_8b1c0c52`,
	"table__col_default-padding": `table__col_default-padding_8b1c0c52`,
	"table__col_left": `table__col_left_8b1c0c52`,
	"table__col_center": `table__col_center_8b1c0c52`,
	"table__col_right": `table__col_right_8b1c0c52`,
	"table__col_caption": `table__col_caption_8b1c0c52`,
	"table__col_block": `table__col_block_8b1c0c52`,
	"table__col_number": `table__col_number_8b1c0c52`,
	"table_data-table-rows": `table_data-table-rows_8b1c0c52`
};
export default ___CSS_LOADER_EXPORT___;
